import { Lightbulb, LayoutList, Tag, Target, Eye, Info } from "lucide-react";
import { eur } from "@/lib/format";
import { t } from "@/i18n";

const TYPE = {
  structure: [LayoutList, t("menuInsights.structure")], prix: [Tag, t("menuInsights.prix")], positionnement: [Target, t("menuInsights.positionnement")],
  lisibilite: [Eye, t("menuInsights.lisibilite")], opportunite: [Lightbulb, t("menuInsights.opportunite")],
};
const IMPACT = { fort: "bg-rose-500/15 text-rose-600 dark:text-rose-400", moyen: "bg-amber-500/15 text-amber-600 dark:text-amber-400", faible: "bg-muted text-muted-foreground" };

export const catLine = (cats) => cats.map((c) => `${c.dish_count} ${c.name.toLowerCase()}`).join(" • ");

export function StatTiles({ stats }) {
  const p = stats.prices;
  const tiles = [
    [t("menuInsights.plats_detectes"), stats.dish_count, `${t("menuInsights.n_sections", { v0: stats.category_count })}${stats.formula_count ? t("menuInsights.x_formule_s", { v0: stats.formula_count }) : ""}`, "menu-stat-dishes"],
    [t("common.prix_moyen"), p.avg ? eur(p.avg) : "—", p.median ? t("menuInsights.mediane_x", { v0: eur(p.median) }) : t("menuInsights.prix_non_lisibles"), "menu-stat-avg"],
    [t("menuInsights.fourchette"), p.min ? `${eur(p.min)} – ${eur(p.max)}` : "—", stats.cheapest ? `${stats.cheapest.name} → ${stats.most_expensive.name}` : "", "menu-stat-range"],
  ];
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {tiles.map(([l, v, s, id], i) => (
        <div key={id} className={`min-w-0 rounded-xl border bg-card p-4 fade-up ${i === 2 ? "col-span-2 sm:col-span-1" : ""}`} style={{ animationDelay: `${i * 80}ms` }} data-testid={id}>
          <p className="eyebrow text-[10px] sm:text-xs">{l}</p>
          <p className="num mt-2 text-xl font-bold sm:text-2xl" data-testid={`${id}-value`}>{v}</p>
          <p className="mt-1 truncate text-[11px] text-muted-foreground sm:text-xs" title={s}>{s}</p>
        </div>
      ))}
    </div>
  );
}

export function ObservationCard({ o, i }) {
  const [Icon, label] = TYPE[o.type] || TYPE.opportunite;
  return (
    <article className="rounded-xl border bg-card p-4 fade-up sm:p-5" style={{ animationDelay: `${200 + i * 90}ms` }} data-testid={`menu-observation-${i}`}>
      <div className="mb-2 flex flex-wrap items-center gap-2">
        <span className="inline-flex items-center gap-1.5 rounded-md bg-[hsl(var(--ai)/0.12)] px-2 py-0.5 text-[11px] font-semibold text-[hsl(var(--ai))]"><Icon className="h-3 w-3" />{label}</span>
        {o.impact && <span className={`rounded-md px-2 py-0.5 text-[11px] font-semibold ${IMPACT[o.impact] || IMPACT.faible}`}>{t(`menuInsights.impact_${o.impact}`)}</span>}
      </div>
      <h3 className="font-semibold leading-snug">{o.title}</h3>
      <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{o.detail}</p>
    </article>
  );
}

export function MarginNote() {
  return (
    <div className="flex gap-3 rounded-xl border border-emerald-500/30 bg-emerald-500/5 p-4 text-sm" data-testid="menu-margin-note">
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" />
      <p className="text-muted-foreground"><span className="font-semibold text-foreground">{t("menuInsights.votre_carte_affiche_les_prix_pas_les_couts")}</span> {t("menuInsights.les_marges_reelles_et_le_cout_matiere_de_c")}</p>
    </div>
  );
}
